
import { Component, Vue, Prop } from "vue-property-decorator";
import { namespace, Getter, Mutation, Action } from "vuex-class";
import NavHeader from "@/components/NavHeader.vue";
import { UserPermissions, FeaturesList } from "@/store/types";
import GenericTable, { TableHeader } from "@/components/table/generic-table.vue";
import { ModalItem } from "@/components/table/generic-update-modal.vue";
import { get } from "lodash";
import { ContactRole } from "@/store/user-management/types";

const UserManagement = namespace("userManagement");

@Component({
	components: {
		"nav-header": NavHeader,
		"generic-table": GenericTable
	}
})
export default class ContactsPage extends Vue {
	@Getter getPermissions: UserPermissions;

	@Getter("getFeaturesList") featuresList: FeaturesList;
	@Getter("getUserId") public currentUserId!: number;

	@UserManagement.Action loadContactRoleList: any;
	@UserManagement.Action updateContactRole: any;
	@UserManagement.Action deleteContactRole: any;
	@UserManagement.Action createContactRole: any;

	// show or hide the page header
	@Prop({ default: true, type: Boolean }) showHeader;

	//show or hide the ID column in the table and modal
	@Prop({ default: true, type: Boolean }) showIdColumn;

	public roleList: ContactRole[] = [];

	private isLoading: boolean = false;

	public columns: TableHeader[] = [
		{
			title: "Contact Role ID",
			key: "contactRoleId",
			order: 1,
			sortOrder: 0,
			sortOrderReversed: false,
			description: "The contact role ID",
			searchable: false,
			visible: this.showIdColumn,
			dataType: "input",
			width: "130px"
		},
		{
			title: "Role Name",
			key: "role",
			order: 2,
			sortOrder: 0,
			sortOrderReversed: false,
			description: "The role name",
			searchable: true,
			visible: true,
			dataType: "input"
		}
	];

	private modalItems: ModalItem[] = [
		{
			title: "Contact Role ID",
			key: "contactRoleId",
			dataType: "text",
			updateOnly: true,
			readOnly: true,
			visible: this.showIdColumn,
			order: 0
		},
		{
			title: "Role Name",
			key: "role",
			dataType: "text",
			readOnly: false,
			required: true,
			placeholder: "Manager",
			order: 1
		}
	];

	private async openUpdateModal(row) {}

	public async updateContactRoleDetails(contactToUpdate: ContactRole) {
		var roleIndex = this.roleList.findIndex(x => x.contactRoleId == contactToUpdate.contactRoleId);

		await this.updateContactRole(contactToUpdate);

		Vue.set(this.roleList, roleIndex, contactToUpdate);
	}

	public async newContactRoleDetails(roleToAdd) {
		let newRole = await this.createContactRole(roleToAdd);
		this.roleList.push(newRole);
	}

	public async deleteContactRoleDetails(roleToDelete: ContactRole) {
		const updateIndex = this.roleList.findIndex((x: ContactRole) => x.contactRoleId == roleToDelete.contactRoleId);

		if (updateIndex >= 0) {
			this.roleList.splice(updateIndex, 1);
		}

		await this.deleteContactRole(roleToDelete.contactRoleId);
	}

	//check feature is on
	public get contactRolePageEnabled() {
		return get(this.featuresList, ["Contacts", "ManageContactRoles"]);
	}

	public async updateData() {
		this.roleList = await this.loadContactRoleList();
	}

	async mounted() {
		this.isLoading = true;
		// if feature is on and we have permission to access it
		if (
			!this.contactRolePageEnabled ||
			!this.getPermissions.isAdmin ||
			!this.getPermissions.canManageContactRoles
		) {
			this.$router.push("/contacts");
		}

		await this.updateData();
		this.isLoading = false;
	}
}
